import { InsuredRelationEnum } from '../../enums/InsuredRelationEnum';

export class InsuranceDto {
  insurerHasAnotherInsurer: boolean;
  tafInsurer: boolean;
  nameInsurer: string;
  dateOfCommencement: Date;
  cancellationDate: null | Date;
  sumAssured: number;
  willCancelPolicy: boolean;
  insuredRelation: InsuredRelationEnum;
}


export class InsuranceGGDto {
  cancellationDate: Date;
  companyName: string;
  insurerWillCancelInsurance: boolean;
  sumAssured: number;
}
